"use strict";

// Transparent Header
const sidebar = document.querySelector(".sidebar");
const sidebarContainer = document.querySelector(".sidebar__container");
const sidebarMenus = document.querySelector(".sidebar__menus");
const primaryMenu = document.querySelector('.primary-menu');
const secondaryMenu = document.querySelector('.secondary-menu');
const sidebarSubMenu = document.querySelector(".sidebar__menu-submenu");
const secondaryMenuItems = document.querySelectorAll(".econdary-menu-item");
const menuItems = document.querySelectorAll(".menu-item");
const menuItemsWithoutSubitems = document.querySelectorAll(".has-not-submenu");
const subMenuDivs = document.querySelectorAll(".sidebar__menu-submenu");
const secondarySubMenuDivs = document.querySelectorAll(".sidebar__secondary-menu-submenu");
const btnBackMenu = document.querySelector(".sidebar__menus-back");
const secondSubmenusDiv = document.querySelectorAll(".sidebar__submenu");
const openSecondSubmenu = document.querySelectorAll(".has-second-submenu.open-second-submenu");
const secondSubmenus = document.querySelectorAll(".has-second-submenu");
const allArrows = document.querySelectorAll('.arrow-down');
const arrowOpened = document.querySelector('.arrow-opened');
const productPage = document.getElementById("shopify-section-product");

// Sidebar dropdown menus and transparent feature
if (sidebar) {
  // Transparent header feature
  document.addEventListener("scroll", () => {
    if (
      window.innerWidth <= 948 && (
      !document.location.href.includes("product") && !document.location.href.includes("contact") && !document.location.href.includes("talent") && !document.location.href.includes("collections") && !document.location.href.includes("search"))
    ) {
      const scroll = window.scrollY;

      if (scroll > 0) {
        sidebarContainer.classList.remove("transparent-header");
      } else if (scroll == 0) {
        sidebarContainer.classList.add("transparent-header");
      }
    }
  });

  // Global variables
  let subMenuHeight;
  let subMenuDiv;
  let menuItem;

  //////////// Functions ///////////////

  const closePrimarySubmenus = () => {
    menuItems.forEach((menu) => menu.classList.remove("open-submenu"));
    subMenuDivs.forEach((sub) => (sub.style.height = "0"));
    allArrows.forEach(arr => arr.classList.remove('arrow-clicked'));

    // when the user closes ALL submenus we want hide the arrow
    if (window.innerWidth < 948) btnBackMenu.classList.add('visually-hidden');
  };

  const closeSecondarySubmenus = () => {
    secondSubmenusDiv.forEach((sub) => (sub.style.height = "0"));
    secondSubmenus.forEach((sub) =>
      sub.classList.remove("open-second-submenu")
    );
  };

  const updateSubmenuHeight = function (subMenuItems, subMenuHeight) {
    subMenuDiv.style.height = `calc((${subMenuItems} * 60px) + ${subMenuHeight})`;
  };

  const openSubmenus = (subMenuListItems) => {
    subMenuHeight = `calc((${subMenuListItems} * 60px) + 10px)`;
    subMenuDiv.style.height = subMenuHeight;
    menuItem.classList.add("open-submenu");
  };

  const initNavigation = (navType, e) => {
    const arrow = e.target.closest('.arrow-down');
    const arrowsubMenu = e.target.closest('.arrow-down-second-submenu');
    const arrowOpened = e.target.closest('.arrow-clicked');

    if (!arrow && !arrowsubMenu && !arrowOpened) return;
    
    // when the user opens a second submenu and a second subemnu
    // we want to hide all the second submenus (except for the one he/she has clicked on)
    closeSecondarySubmenus();

    if (arrow?.classList.contains('arrow-clicked')) {
      closePrimarySubmenus();

      return;
    }

    // open submenus
    if (arrow) {
      closePrimarySubmenus();
      arrow.classList.add('arrow-clicked');

      const data = navType === 'primary' ? arrow.dataset.primaryMenu : arrow.dataset.secondaryMenu;

      subMenuDiv = document.querySelector(`.sidebar__${navType}-menu-submenu--${data}`);
      menuItem = document.getElementById(`${navType}-menu-item--${data}`);
      
      // class => submenu-secondary-list--${data}
      const subMenuList = document.querySelector(`.submenu-${navType}-list--${data}`);
      const subMenuListItems = subMenuList.children.length;
      openSubmenus(subMenuListItems);

      // on mobile and small devices, we want to show the arrow 
      // when the user opens a new submenu
      if (window.innerWidth < 948) btnBackMenu.classList.remove('visually-hidden');
    };

    // open second submenu (the user has clicked)
    if (arrowsubMenu) {
      // we have to add this class to the current sub menu item
      // to keep the arrow down
      menuItem.classList.add('open-submenu');

      const data = navType === 'primary' ? arrowsubMenu.dataset.primarySubmenu : arrowsubMenu.dataset.secondarySubmenu;

      const submenuItem = document.querySelector(`.${navType}-second-submenu--${data}`);
      const secondSubmenuList = document.querySelector(`.${navType}-second-submenu-list--${data}`);
      const secondSubmenuListItems = secondSubmenuList.children.length;
      const secondSubmenuDiv = document.querySelector(`.sidebar__${navType}-submenu--second-${data}`);
      secondSubmenuDiv.style.height = `calc(${secondSubmenuListItems} * 30px)`;
      submenuItem.classList.add('open-second-submenu');

      // update the height of the div
      updateSubmenuHeight(secondSubmenuListItems, subMenuHeight, secondSubmenuListItems);
    }
  }

  //////////// Actions ///////////////
  primaryMenu.addEventListener("click", (e) => {
    initNavigation('primary', e);
  });

  secondaryMenu.addEventListener('click', (e) => {
    initNavigation('secondary', e);
  });

  // Mobile (close submenus, second submenus and preventing default anchor behaviour)
  btnBackMenu.addEventListener("click", (e) => {
    closePrimarySubmenus();
    closeSecondarySubmenus();
  });
}

if (productPage) {
  const thumbnails = document.querySelectorAll(".thumbnail[data-product-color]");
  const colorVariant = document.querySelector(".product__variants");
  const colorVariantOpt = document.querySelector(".product__variant--color");
  const colorVariantBackOpt = document.querySelector(".product__variant--back");
  const capacityVariantOpt = document.querySelector(
    ".product__variant--capacity"
  );
  const visorVariantOpt = document.querySelector(".product__variant--visor");
  const strapColorVariantOpt = document.querySelector(
    ".product__variant--strap-color"
  );
  const optionCheckboxes = document.querySelectorAll('.product__variant:checked');
  const imgSlider = document.querySelector(".product-gallery--slider, .product-gallery");
  const imgScrolling = document.querySelector(".product-gallery--scroll");
  const productSlides = document.querySelectorAll(".product-gallery__item");
  const productSizes = document.querySelector(".product__sizes-guide");
  const sizesInfo = document.querySelector(".sizes-info");
  const sizesInner = document.querySelector(".sizes--inner");
  const tabsDiv = document.querySelector(".tabs-list");
  const tabs = document.querySelectorAll(".product-tab");
  const tabsContents = document.querySelectorAll(".product-tab-content");
  const quantitySelectorDiv = document.querySelector('.product__quantity');
  const quantitySelector = document.querySelector('.quantity__selector');
  const quantityTxt = document.querySelector('.variant-quantity');
  const addCartBtn = document.querySelector('.product__add-to-cart');
  const addCartBtnTxt = document.querySelector('.add-to-cart__text');
  const formCheckboxes = document.querySelector('.form-checkboxes');
  const labels = document.querySelectorAll('.hidden-span');
  const colorOptions = document.querySelector('.product__variant-colors');
  const colorSwatches = document.querySelectorAll('.color-swatch');
  const customerReviews = document.querySelector('.product__customer-reviews');
  const productPrice = document.querySelector('.product__price--original');
  const comparedPrice = document.querySelector('.product__price--compare');
  const addCartBtnDiv = document.querySelector(".product__quantity-submit");
  

  let colorValue = colorVariantOpt?.value.toLowerCase();
  let colorBackValue = colorVariantBackOpt?.value.toLowerCase();
  let capacityValue = capacityVariantOpt?.value
    .toLowerCase()
    .replace(/ml$/, "");
  let visorValue = visorVariantOpt?.value.toLowerCase();
  let strapColorValue = strapColorVariantOpt?.value.toLowerCase();

  const galleryMode = imgSlider ? imgSlider : imgScrolling;

  // display only the variant thumbnails on first loading
  const displayMedia = (
    data,
    item,
    variant1 = colorValue,
    variant2 = colorBackValue,
    variant3 = capacityValue,
    variant4 = visorValue,
    variant5 = strapColorValue
  ) => {
    if (!variant1 && !variant2 && !variant3 && !variant4 && !variant5) return;

    const varArr = new Array(
      variant1,
      variant2,
      variant3,
      variant4,
      variant5
    ).filter((val) => val);

    if (data.every((val, i) => val === varArr[i])) {
      item.classList.remove("hidden");
    } else {
      item.classList.add("hidden");
      item.classList.remove('active');
    }
  };

  const selectSlide = (variant, isInstant = false) => {
    const slide = document.querySelector(`.product-gallery__item[data-product-color="${variant.join('-')}"]`);
    if (!slide) return;

    const slideIndex = slide?.dataset?.index;
    const carousel = new Flickity('.product-gallery');

    carousel.select(slideIndex, undefined, isInstant);
  };

  // change variant slides on scrolling (Form Checkboxes and Select)
  if (galleryMode === imgScrolling && window.innerWidth > 1022) {
    // set the slide of the current selected variant when refreshing
    productSlides.forEach((slide) => {
      const data = slide.dataset.productColor.split('-');

      displayMedia(data, slide);
    });
  } else {
    // set the slide of the current selected variant when refreshing
    window.addEventListener("load", function(){
      const checkedOptions = document.querySelectorAll('.product__variant:checked');
      const slideVariants = []
      checkedOptions.forEach(opt => {
        if (opt.classList.contains('visual-variant')) {
          slideVariants.push(opt.getAttribute('value').toLowerCase().replace('ml', ''));
        }
      });
      selectSlide(slideVariants, true);
    });
  }

  // display only the variant thumbnails (when refreshing the page or visiting it for the 1st time)
  if (!formCheckboxes) {
    thumbnails.forEach((thumb) => {
      const data = thumb.dataset.productColor.split("-");
      if (!data) return;
    
      displayMedia(data, thumb);
    });
  }

  // update URL Params
  const updateUrlParams = (id) => {
    const newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id;
      window.history.replaceState({path: newurl}, '', newurl);
  };

  const updateProductPage = (variant, selectedVar) => {
    const { compare_at_price, inventory_policy, inventory_quantity, options, price } = variant
    let currency = '€';
    if (Shopify.currency.active === 'USD') {
      currency = '$';
    } else if (Shopify.currency.active === 'GBP') {
      currency = '£'
    }
    
    const finalPrice = `${currency}${(price / 100).toFixed(2)}`;
    const oldPrice = `${currency}${(compare_at_price / 100).toFixed(2)}`;

    const finalPriceFormatted = parseFloat(finalPrice.substring(1));
    const oldPriceFormatted = parseFloat(oldPrice.substring(1));
    
    if (oldPriceFormatted > finalPriceFormatted) {
      comparedPrice.textContent = oldPrice;
    } else {
      comparedPrice.textContent = "";
    }

    if (inventory_quantity > 0 || inventory_policy === 'continue') {
      quantitySelectorDiv.style.display = 'block';
      quantitySelector.style.display = 'block';
      quantitySelector.setAttribute('max', 999);
      addCartBtnTxt.textContent = addCartBtnTxt.dataset.addToCartText;
      addCartBtn.disabled = false;
      addCartBtn.classList.remove('disabled');

      const varQuantity = +selectedVar?.dataset.quantity;
      
      inventory_policy !== 'continue' && varQuantity <= 5 ? quantityTxt.textContent = `There ${varQuantity == 1 ? 'is' : 'are'} ${varQuantity} product${varQuantity == 1 ? '' : 's'} left` : quantityTxt.textContent = '';
    
    } else {
      addCartBtn.disabled = true;
      addCartBtn.classList.add('disabled');
      addCartBtnTxt.textContent = 'Sold out';
      quantitySelectorDiv.style.display = 'none';
      quantitySelector.style.display = 'none';
      quantitySelector.removeAttribute('max');
      quantityTxt.textContent = 'There are no products left';
    }
    productPrice.textContent = finalPrice;
    addCartBtnDiv.classList.remove("hidden");
  }

  const waitForShopifyProductPage = (variant, selectedVar) => {
    if (window.Shopify) {
        updateProductPage(variant, selectedVar);
    } else {
      setTimeout(function() {
        waitForShopifyProductPage(variant, selectedVar)
      }, 1000);
    }
  }
  
  // get all the information about the current variant to fill the 
  // info. on the product page
  const productAJAXCall = (variantId, selectedVar) => {
    const productHandle = document.getElementById("section-product").dataset.productHandle;

    fetch(`/products/${productHandle}.js`)
    .then(res => res.json())
    .then(data => {
      const variant = data.variants.filter(vari => vari.id === variantId)[0];
      
      waitForShopifyProductPage(variant, selectedVar);
    })
  }

  // update the master selector and get the current variant id
  const updateMasterSelector = (variant) => {
    const selectedVariant = document.querySelector(`option[data-variant-value="${variant}"]`);

    if (!selectedVariant) return;

    const variantId = selectedVariant.getAttribute('value');
    const allOptions = document.querySelectorAll('option[data-variant-value]');
    allOptions.forEach(opt => opt.removeAttribute('selected'));

    if (!selectedVariant.hasAttribute('selected')) {
      selectedVariant.setAttribute('selected', 'selected');
    }

    updateUrlParams(variantId);
    productAJAXCall(+variantId, selectedVariant);
  };

  const initMedia = (items, colors) => {
    const color = colors.join('-');

    items.forEach(item => {
      const slideColors = item.dataset.productColor;
      if (slideColors !== color) {
        item.classList.add('hidden');
      } else {
        item.classList.remove('hidden');
      }
    })
  };

  // TODO: Add some control flow
  // get all the checked values
  // only runs when the form input option is "Checkboxes"
  const initProductFormCheckboxes = () => {
    const variant = [];
    const colors = []

    optionCheckboxes.forEach(opt => {
      variant.push(opt.getAttribute('value'));

      const color = opt.dataset.color;

      if (!color) return;
      colors.push(color.toLowerCase());
    });

    // to display only the selected variant thumbnails and slides 
    // when the screen is bigger than 1022px
    // the gallery is always a slider on small devices
    if (galleryMode === imgScrolling && colors.length > 0 && window.innerWidth > 1022) {
      initMedia(productSlides, colors);
      initMedia(thumbnails, colors);
    } else if (colors.length > 0 && window.innerWidth <= 1022) {
      initMedia(thumbnails, colors);
    }

    if (!variant.length && document.location.search.length || document.getElementById("section-product").dataset.onlyDefaultVariant === "true") {
      const variant = document.querySelector('.masterSelect-option[selected="selected"]');
      variant.dataset.variantValue.split(" / ").forEach(opt => document.querySelector(`input.product__variant[value="${opt}"]`).click());
    }
  };

  // We want to display the correct media
  // when the values of the input change
  colorVariant.addEventListener("change", (e) => {
    const input = e.target;

    thumbnails.forEach((thumb) => {
      const data = thumb.dataset.productColor.split("-");
      if (!data) return;

      if (input.classList.contains("product__variant--color")) {
        colorValue = input.value.toLowerCase();

        displayMedia(data, thumb, colorValue);
      }

      if (input.classList.contains("product__variant--back")) {
        colorBackValue = input.value.toLowerCase();

        displayMedia(data, thumb, undefined, colorBackValue);
      }

      if (input.classList.contains("product__variant--capacity")) {
        capacityValue = input.value.toLowerCase().replace(/ml$/, "");


        displayMedia(data, thumb, undefined, undefined, capacityValue);
      }

      if (input.classList.contains("product__variant--visor")) {
        visorValue = input.value.toLowerCase();

        displayMedia(data, thumb, undefined, undefined, undefined, visorValue);
      }

      if (input.classList.contains("product__variant--strap-color")) {
        strapColorValue = input.value.toLowerCase();

        displayMedia(data, thumb, undefined, undefined, undefined, undefined, strapColorValue);
      }
    });

    // displaying the current variant media
    if (formCheckboxes) {
      const checkedOptions = document.querySelectorAll('.product__variant:checked');
      const variant = [];
      checkedOptions.forEach(opt => variant.push(opt.getAttribute('value')));
      
      updateMasterSelector(variant.join(" / "));

      if (galleryMode === imgSlider) {
        const productVariants = []
        checkedOptions.forEach(opt => {
          if (opt.classList.contains('visual-variant')) {
            productVariants.push(opt.getAttribute('value').toLowerCase().replace('ml', ''));
          }
        });

        if (productVariants.length > 0) {
          initMedia(thumbnails, productVariants);
        }
        selectSlide(productVariants);
      }

      if (galleryMode === imgScrolling) {
        const variant = [];
        checkedOptions.forEach(opt => {
          if (opt.classList.contains('visual-variant')) {
            variant.push(opt.getAttribute('value').toLowerCase().replace('ml', ''));
          }
        });

        if (variant.length > 0) {
          // on small devices, the gallery is always a slider
          // so we want to call this fn only on big screens
          if (window.innerWidth > 1022) {
            initMedia(productSlides, variant);
          }
        
        initMedia(thumbnails, variant);
        }
      }
    }

    // to display only the selected variant thumbnails and slides 
    // when the screen is bigger than 1022px
    // the gallery is always a slider on small devices
    if (!formCheckboxes && galleryMode === imgScrolling && window.innerWidth > 1022) {
      productSlides.forEach(slide => {
        const data = slide.dataset.productColor.split("-");

        displayMedia(data, slide)
      });
    }
  });

  // Saber cuándo hay un cambio de variante en el slider
  galleryMode.addEventListener("transitionrun", (e) => {
    if (!e.target.closest(".is-selected")) return;

    const dataColor = e.target.dataset.productColor;

    if (!dataColor) return;
    initMedia(thumbnails, dataColor.split('-'))
  });

  if (formCheckboxes) {
    initProductFormCheckboxes();
  }

  //////////////////////// **************************** ////////////////////////
  //////////////////////// SIZES, TABS AND COLOR LABELS ////////////////////////
  //////////////////////// **************************** ////////////////////////

  // Acordeón guía de tallas
  productSizes?.addEventListener("click", (e) => {
    const title = e.target.closest(".product__sizes-guide");
    if (!title) return;
    title.classList.toggle("opened-guide");

    const height = sizesInner.offsetHeight;

    if (title.classList.contains("opened-guide")) {
      sizesInfo.style.height = `${height}px`;
    } else {
      sizesInfo.style.height = 0;
    }
  });

  // product page info tabs (product details, shippings, etc...)
  tabsDiv.addEventListener("click", (e) => {
    const tab = e.target.closest(".product-tab");

    if (!tab) return;
    const data = tab.dataset.tab;

    tabs.forEach((tab) => tab.classList.remove("active-tab"));
    tabsContents.forEach((tab) => {
      tab.classList.add("hidden-tab");
    });

    const newTab = document.querySelector(`.product-tab--${data}`);
    const newTabContent = document.querySelector(
      `.product-tab-content--${data}`
    );

    newTab.classList.add("active-tab");
    newTabContent.classList.remove("hidden-tab");
  });

    // show and hide color swatches labels
  colorSwatches.forEach(swatch => {
    swatch.addEventListener('mouseover', (e) => {
      if (window.innerWidth > 1024) {
        const color = e.target.closest('.color-swatch');
    
        if (!color) return;
    
        const data = e.target.dataset.label;
        const label = document.querySelector(`.span--${data}`);

        if (!label) return;
        label.classList.remove('visually-hidden');
      }
    });

    swatch.addEventListener('mouseleave', (e) => {
      if (window.innerWidth > 1024) {
        const color = e.target.closest('.color-swatch');
        
        if (!color) return;
        
        const data = e.target.dataset.label;
        const label = document.querySelector(`.span--${data}`);
        label.classList.add('visually-hidden');
      } 
    });
  })

  //////////////////////// **************************** ////////////////////////
  ////////////////////////// PRODUCT CUSTOMER REVIEWS //////////////////////////
  //////////////////////// **************************** ////////////////////////

  if (customerReviews) {
    const arrowLeft = document.querySelector('.product__customer-reviews-left');
    const arrowRight = document.querySelector('.product__customer-reviews-right');
    const userReviewsSlider = document.querySelector('.product__customer-reviews--slider');
    const userReviews = document.querySelectorAll('.product__customer-review');
    const userReviewsSection = document.querySelector('.product__customer-reviews');
    const userReviewsContent = document.querySelector('.product__customer-reviews--content');
    const controls = document.querySelector('.product__customer-reviews-controls');
    let movement = 0;
    let currentSlide = 1;
    let distance = 0;

    // backwards
    arrowLeft?.addEventListener('click', (e) => {
      const arrow = e.target.closest('.prev');
      arrowRight.classList.remove('disabled');

      if (!arrow) return;
      if (arrow.classList.contains('disabled')) return;

      currentSlide--;

      if (currentSlide == 1) arrow.classList.add('disabled');

      movement -= distance;
      userReviewsSlider.style.transform = `translateX(-${movement}%)`;
    });

    // forward
    arrowRight?.addEventListener('click', (e) => {
      const arrow = e.target.closest('.next');
      arrowLeft.classList.remove('disabled');

      if (!arrow) return;
      if (arrow.classList.contains('disabled')) return;

      currentSlide++;

      if (currentSlide == userReviews.length) arrow.classList.add('disabled');

      movement += distance;
      userReviewsSlider.style.transform = `translateX(-${movement}%)`;
    });

    document.addEventListener('DOMContentLoaded', () => {
      if (userReviewsSlider.length === 0) {
        controls.style.display = 'none'
      } else {
        const width = userReviews.length * 100;
        const movementSlider = (100 / userReviews.length);
        
        userReviewsSlider.style.width = `${width}%`;
        distance = movementSlider;
      }

      setTimeout(() => {
        userReviewsSection.classList.remove('reviews-effect');
        userReviewsContent.classList.remove('visually-hidden');
      }, 1000);
    });
  }
}